import { render } from "./InvoicePage.vue?vue&type=template&id=7bdbef82&scoped=true"
import script from "./InvoicePage.vue?vue&type=script&lang=js"
export * from "./InvoicePage.vue?vue&type=script&lang=js"

import "./InvoicePage.vue?vue&type=style&index=0&id=7bdbef82&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdbef82"]])

export default __exports__